'use client';

import { useEffect } from 'react';

function closeDesktopMenus() {
  const noneRadio = document.getElementById(
    'desktop-menu-none'
  ) as HTMLInputElement | null;
  if (noneRadio) noneRadio.checked = true;
}

function closeMobileMenu() {
  const mobileCheckbox = document.getElementById(
    'mobile-menu-toggle'
  ) as HTMLInputElement | null;
  if (mobileCheckbox?.checked) {
    mobileCheckbox.checked = false;
    window.dispatchEvent(
      new CustomEvent('navMenuStateChange', { detail: { isOpen: false } })
    );
  }
  document
    .querySelectorAll('.mobile-menu-accordion[open]')
    .forEach((details) => {
      (details as HTMLDetailsElement).open = false;
    });
}

function closeAllMenus() {
  closeMobileMenu();
  closeDesktopMenus();
}

export function NavigationScript() {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeAllMenus();
    };

    const handleNavLinkClick = (e: Event) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href]') as HTMLAnchorElement | null;
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;

      closeAllMenus();
    };

    const handleHashChange = () => {
      if (window.location.hash === '#contact-sales') {
        closeAllMenus();
      }
    };

    const handleMobileMenuChange = () => {
      const mobileCheckbox = document.getElementById(
        'mobile-menu-toggle'
      ) as HTMLInputElement | null;
      if (mobileCheckbox) {
        window.dispatchEvent(
          new CustomEvent('navMenuStateChange', {
            detail: { isOpen: mobileCheckbox.checked },
          })
        );
      }
    };

    // Close desktop menu when clicking outside the header
    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const header = document.querySelector('header');
      if (!header?.contains(target)) {
        closeDesktopMenus();
      }
    };

    // Close language toggle details when clicking outside
    const handleDetailsOutsideClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const openDetails = document.querySelectorAll(
        '.language-toggle-details[open]'
      );
      openDetails.forEach((details) => {
        if (!details.contains(target)) {
          (details as HTMLDetailsElement).open = false;
        }
      });
    };

    const navMenu = document.getElementById('nav-menu');
    const mobileCheckbox = document.getElementById('mobile-menu-toggle');

    // ever since we've reworked the navigation to be SSR-compatible, clicking links
    // makes the page scroll to the top when links are clicked/focused.
    // this hack stops that from happening.
    const preventNavScrollOnFocus = (e: FocusEvent) => {
      if ((e.target as HTMLInputElement)?.name === 'desktop-menu') {
        window.scrollTo(0, savedScrollY);
      }
    };
    let savedScrollY = 0;
    const saveScroll = () => {
      savedScrollY = window.scrollY;
    };

    document.addEventListener('keydown', handleEscape);
    navMenu?.addEventListener('click', handleNavLinkClick);
    window.addEventListener('hashchange', handleHashChange);
    mobileCheckbox?.addEventListener('change', handleMobileMenuChange);
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('click', handleDetailsOutsideClick);
    document.addEventListener('mousedown', saveScroll, true);
    document.addEventListener('focusin', preventNavScrollOnFocus, true);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      navMenu?.removeEventListener('click', handleNavLinkClick);
      window.removeEventListener('hashchange', handleHashChange);
      mobileCheckbox?.removeEventListener('change', handleMobileMenuChange);
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('click', handleDetailsOutsideClick);
      document.removeEventListener('mousedown', saveScroll, true);
      document.removeEventListener('focusin', preventNavScrollOnFocus, true);
    };
  }, []);

  return null;
}
